// extracted by mini-css-extract-plugin
module.exports = {"grid":"DetailsModal_grid__qqOdR","button":"DetailsModal_button__S0VxV","iconContainer":"DetailsModal_iconContainer__mJAJE"};